import { ThemeProvider } from "@locus-taxy/neo-ui";
import { GroupTable } from "./GroupTable";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { updateLoader } from "../../redux/action/loaderAction";
import { slotsFetch } from "../../redux/action/teamActions";
import React from "react";

export const Groups = ({ openNotificationWithIcon }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { clientId, authToken } = queryString.parse(location.search);

  useEffect(
    () => {
      dispatch(updateLoader({ reconLoading: true }));
      dispatch(slotsFetch({ clientId, authToken }, navigate, handleError));
    }, //eslint-disable-next-line
    [authToken, clientId, dispatch]
  );

  const handleError = (error) => {
    dispatch(updateLoader({ reconLoading: false }));
    openNotificationWithIcon(
      "error",
      "Something went wrong",
      JSON.stringify(
        error?.message || error?.errorResponse?.errorMessage || error
      )
    );
  };
  return (
    <>
      <ThemeProvider>
        <GroupTable openNotificationWithIcon={openNotificationWithIcon} />
      </ThemeProvider>
    </>
  );
};
